<template>
    <v-container class="pt-0 pb-5" v-if="inscriptionStore.id && alerte_sms_contacts">
        <v-row>
            <v-col>
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="FicheCoureur" chevronLeft>Retour</SportipsButton>
                    </div>
                    <div class="text-h5 font-weight-bold text-darkblue mt-2">Contacts pour les alerte SMS
                    </div>
                    <div>Vous pouvez renseigner les numéros de téléphone de vos accompagnants jusqu'au jour de la
                        course.</div>
                    <div>
                        <div class="field_label">Premier contact</div>

                        <v-phone-input v-model="alerte_sms_contacts.contact_1" label="Numéro de téléphone"
                            class="phone-input-field" default-country="FR" :disable-guessing-country="true"
                            :only-countries="['FR']" invalid-message="Ce numéro de téléphone n'est pas valide" />
                    </div>
                    <div>
                        <div class="field_label">Deuxième contact</div>
                        <v-phone-input v-model="alerte_sms_contacts.contact_2" label="Numéro de téléphone"
                            class="phone-input-field" default-country="FR" :disable-guessing-country="true"
                            :only-countries="['FR']" invalid-message="Ce numéro de téléphone n'est pas valide" />
                    </div>
                    <div>
                        <div class="field_label">Troisième contact</div>
                        <v-phone-input v-model="alerte_sms_contacts.contact_3" label="Numéro de téléphone"
                            class="phone-input-field" default-country="FR" :disable-guessing-country="true"
                            :only-countries="['FR']" invalid-message="Ce numéro de téléphone n'est pas valide" />
                    </div>
                    <div>
                        <SportipsButton icon="mdi-content-save" color="primary-dark" @click="save_alerte_sms_contacts">
                            Enregistrer les modifications</SportipsButton>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useInscriptionStore } from "@/stores/inscriptionStore";
export default {
    data() {
        return {
            alerte_sms_contacts: null,
        };
    },
    computed: {
        ...mapStores(useMainStore, useInscriptionStore),

    },

    methods: {
        async save_alerte_sms_contacts() {
            let request = this.inscriptionStore.save_alerte_sms_contacts(this.alerte_sms_contacts);
            if (request) {
                this.mainStore.notification.send("Les numéros de téléphone de vos accompagnants ont été enregistrés", "success");
                this.$router.push({ name: "FicheCoureur" });
            }
            else {
                this.mainStore.notification.send("Une erreur est survenue lors de l'enregistrement des numéros de téléphone de vos accompagnants", "error");
            }
        }
    },

    async mounted() {
        if (!this.mainStore.authUser.isLogged) {
            this.mainStore.notification.send("Vous devez être connecté pour renseigner les numéros de téléphone de vos accompagnants", "error");
            this.$router.push({ name: "FicheCoureur" });
        }
        if (!this.mainStore.module.has_alerte_sms) {
            this.mainStore.notification.send("Les alerte SMS n'est pas disponible sur cet évènement", "error");
            this.$router.push({ name: "FicheCoureur" });
        }
        this.inscriptionStore.init();
        this.inscriptionStore.id = this.$route.params.id_inscription;
        let request = await this.inscriptionStore.get();
        if (!request) {
            this.mainStore.notification.send("Une erreur est survenue lors de la récupération de votre inscription", "error");
            this.$router.push({ name: "FicheCoureur" });
        }
        let request_alerte_sms = await this.inscriptionStore.get_alerte_sms_contacts();
        if (!request_alerte_sms) {
            this.mainStore.notification.send("Une erreur est survenue lors de la récupération des numéros de téléphone de vos accompagnants", "error");
            this.$router.push({ name: "FicheCoureur" });
        }
        this.alerte_sms_contacts = request_alerte_sms;

    }


}
</script>

<style lang="scss" scoped>
::v-deep(.phone-input-field .v-phone-input__country__input) {
    display: none !important;
}
</style>